// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/app-" + chunkId + "." + {"3042":"86817368","5858":"5094f1b8","7378":"3071f593","9725":"c7cc986e"}[chunkId] + ".chunk.css";
};